import { SetStateAction } from 'react'
import { MAKE, MANUFACTURER, MODEL } from '../constants/filter.constants'
import { AssetType } from '../types/bucketTypes'

interface FilterType {
    category: string
    type: {
        title: string
        originalTitle?: string
        checked: boolean
        id?: string
        category?: string
    }[]
}

export const getFilters = (assets: AssetType[]) => {
    let make: string[] = []
    let manufacturer: string[] = []
    let model: string[] = []

    assets.forEach((value, i) => {
        make[i] = value.bucket[MAKE] as string
        manufacturer[i] = value.bucket[MANUFACTURER] as string
        model[i] = value.bucket[MODEL] as string
    })

    make = [...new Set(make)]
    manufacturer = [...new Set(manufacturer)]
    model = [...new Set(model)]

    // Find items that appear in multiple categories
    const allItems = [...make, ...manufacturer, ...model]
    const duplicates = new Set<string>()
    
    allItems.forEach(item => {
        let count = 0
        if (make.includes(item)) count++
        if (manufacturer.includes(item)) count++
        if (model.includes(item)) count++
        
        if (count > 1) {
            duplicates.add(item)
        }
    })

    const filters: SetStateAction<FilterType[]> = [
        {
            category: 'Make',
            type: make.map((item: string) => {
                const needsSuffix = duplicates.has(item)
                return {
                    title: needsSuffix ? `${item} (Make)` : item, // Add suffix only for duplicates
                    originalTitle: item, // Keep clean original for filtering
                    checked: false,
                    id: `make-${item}`, // Unique ID to distinguish categories
                    category: 'make', // Add category info to each item
                }
            }),
        },
        {
            category: 'Model',
            type: model.map((item: string) => {
                const needsSuffix = duplicates.has(item)
                return {
                    title: needsSuffix ? `${item} (Model)` : item, // Add suffix only for duplicates
                    originalTitle: item, // Keep clean original for filtering
                    checked: false,
                    id: `model-${item}`, // Unique ID to distinguish categories
                    category: 'model', // Add category info to each item
                }
            }),
        },
        {
            category: 'Manufacturer',
            type: manufacturer.map((item: string) => {
                const needsSuffix = duplicates.has(item)
                return {
                    title: needsSuffix ? `${item} (Manufacturer)` : item, // Add suffix only for duplicates
                    originalTitle: item, // Keep clean original for filtering
                    checked: false,
                    id: `manufacturer-${item}`, // Unique ID to distinguish categories
                    category: 'manufacturer', // Add category info to each item
                }
            }),
        },
    ]

    return filters
}
